import DashboardContainer from 'components/smart/dashboard-container/DashboardContainer'
import React from 'react'
import ACButton from '../components/ACButton'
import ACTabs from '../components/ACTabs'
import { Box } from '@mui/material'

const AppraisalCycle = () => {
  return (
    <DashboardContainer headerTitle="Appraisal">
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
        <ACButton />
        <ACTabs />
      </Box>
    </DashboardContainer>
  )
}

export default AppraisalCycle
